// components/ResultTable.tsx
import React from "react";

type ResultTableProps = {
  tableData?: any[];
  compact?: boolean;
  fill?: boolean;
  noBorder?: boolean;
};

const ResultTable: React.FC<ResultTableProps> = ({ tableData, compact, fill, noBorder }) => {

  // Kiểm tra dữ liệu đầu vào
  if (!tableData?.length) return null;

  // Tạo ma trận 6 hàng x 12 cột (tối đa 72 ô)
  const matrix: (number | null)[][] = Array.from({ length: 12 }, () =>
    Array.from({ length: 6 }, () => null)
  );

  // Lấy phần tử sort tăng dần theo thời gian, giới hạn 72 phần tử mới nhất để vừa ma trận
  const sorted = [...tableData].sort((a, b) => a.stampTime - b.stampTime);
  const isOverflow = sorted.some((item) => item.showX >= 12);
  const displayItems = isOverflow
    ? sorted.map((item, index) => ({
        ...item,
        showX: Math.floor(index / 6),
        showY: index % 6,
      }))
    : sorted;

  // Chỉ gán tối đa 72 phần tử vào matrix để tránh vượt chỉ số
  const itemsToShow = displayItems.slice(-72);
  itemsToShow.forEach((item: any, index: number) => {
    const col = Math.floor(index / 6);
    const row = index % 6;
    matrix[col][row] = item.road;
  });

  // Hàm map road => ảnh tương ứng
  const getSymbolImage = (road: number) => {
    switch (road) {
      case 0:
        return "/assets/casino/symbol_b_small.png";
      case 1:
        return "/assets/casino/symbol_b_small.png";
      case 2:
        return "/assets/casino/symbol_b_small.png";

      case 8:
        return "/assets/casino/symbol_p_small.png";
      case 9:
        return "/assets/casino/symbol_p_small.png";
      case 10:
        return "/assets/casino/symbol_p_small.png";

      default:
        return "/assets/casino/symbol_t_small.png";
    }
  };

  // Lobby overlay mode: no scroll, align icons perfectly to background grid
  if (compact && fill && noBorder) {
    return (
      <div
        className="w-full h-full overflow-hidden"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(12, 1fr)",
          gridTemplateRows: "repeat(6, 1fr)",
          columnGap: 0,
          rowGap: 0,
        }}
      >
        {Array.from({ length: 6 }, (_, rowIndex) =>
          Array.from({ length: 12 }, (_, colIndex) => {
            const road = matrix[colIndex][rowIndex];
            return (
              <div
                key={`${rowIndex}-${colIndex}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {road !== null && (
                  <img
                    src={getSymbolImage(road)}
                    alt="result"
                    style={{
                      width: "var(--result-icon-size, 26px)",
                      height: "var(--result-icon-size, 26px)",
                      objectFit: "contain",
                    }}
                  />
                )}
              </div>
            );
          })
        )}
      </div>
    );
  }

  const cellClass = noBorder
    ? compact
      ? "text-center align-middle p-0"
      : "text-center align-middle"
    : compact
    ? "border border-green-400/80 text-center align-middle"
    : "border border-green-400 w-7 h-7 text-center align-middle";
  const iconClass = compact
    ? noBorder
      ? "mx-auto w-8 h-8"
      : "mx-auto w-3 h-3"
    : "mx-auto w-5 h-5";
  const cellStyle =
    compact && noBorder
      ? ({
          width: 36,
          height: 36,
        } as React.CSSProperties)
      : undefined;
  const wrapperClass = fill && compact
    ? "overflow-hidden w-full h-full flex justify-start"
    : compact
    ? "overflow-x-auto mt-1"
    : "overflow-x-auto mt-4";
  const tableClass = noBorder
    ? fill && compact
      ? "w-full h-full table-fixed border-separate border-spacing-x-2 border-spacing-y-1"
      : compact
      ? "w-full max-h-[120px] border-separate border-spacing-x-2 border-spacing-y-1"
      : "mx-auto w-full h-[250px] border-separate border-spacing-x-2 border-spacing-y-1"
    : fill && compact
    ? "border-separate border-spacing-0.5 w-full h-full table-fixed"
    : compact
    ? "border-separate border-spacing-0.5 w-full max-h-[120px]"
    : "mx-auto border-separate border-spacing-1 w-full h-[250px]";

  return (
    <div className={wrapperClass}>
      <table className={tableClass}>
        <tbody>
          {Array.from({ length: 6 }, (_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: 12 }, (_, colIndex) => (
                <td key={colIndex} className={cellClass} style={cellStyle}>
                  {matrix[colIndex][rowIndex] !== null && (
                    <img
                      src={getSymbolImage(matrix[colIndex][rowIndex]!)}
                      alt="result"
                      className={iconClass}
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResultTable;
